export const WAITING_MESSAGE_TYPES = 'alert,login,rg:limits-cool-off,bonus,bonus:2,bonus:4';

export const WAITING_MESSAGE_DISABLE_ALL = 'disableAll';

export const WAITING_MESSAGE_LOGIN_TYPE = 'login';
